import homeRouter from './home-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/about',
    component: () => import('@/view/home/home'),
    children: [...homeRouter],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/login/login'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/view/login/register'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/view/login/home'),
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/view/login/forget'),
  },
  {
    redirect: '/404',
    path: '/:pathMatch(.*)',
  },
]

export default routes
